import React from 'react';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import './ToggleStyleSwitch.scss';

export default function ToggleStyleSwitch(props) {

	const AntSwitch = styled(Switch)(({ theme }) => ({
		width: 44,
		height: 24,
		padding: 0,
		display: 'flex',
		alignItems: 'center',
		'& .MuiSwitch-switchBase': {
			padding: 4,
			transitionDuration: '300ms',
			'&.Mui-checked': {
				transform: 'translateX(20px)',
				color: '#fff',
				'& + .MuiSwitch-track': {
					opacity: 1,
					backgroundColor: '#2784B9',
					...theme.applyStyles?.('dark', {
						backgroundColor: '#177ddc',
					}),
				},
			},
		},
		'& .MuiSwitch-thumb': {
			width: 15,
			height: 15,
			borderRadius: 25,
			backgroundColor: '#fff',
			boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
		},
		'& .MuiSwitch-track': {
			borderRadius: 25,
			opacity: 1,
			backgroundColor: 'var(--color-disabled)',
			boxSizing: 'border-box',
			...theme.applyStyles?.('dark', {
				backgroundColor: 'var(--color-darkBorder)',
			}),
		},
	}));

	return (
		<FormControlLabel
			control={
				<AntSwitch
					onChange={props?.onChange}
					checked={props?.checked}
					disabled={props?.disabled}
				/>
			}
			sx={{ marginRight: '1px !important',}}
			label={props?.label}
		/>
	);
}
